'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

/**
 * UI facet filter component (aka one of the items in a facet that you can toggle)
 * Button and Checkbox widgets are handled within this component.
 */
const FacetFilter = function(props) {
    let filterModel = props.filterModel;
    let id = filterModel.getId();
    let checked = true;
    if (!filterModel.isSelected()) {
        checked = false;
    }

    let filterLabel = filterModel.key.replace(/,/g, ',\u200B');

    //  If the match count on the filter is zero then don't display the zero.
    let count = <span>&nbsp;</span>;
    let numCount = filterModel.getMatchCount();
    if (numCount > 0) {
        count = `(${numCount})`;
    }

    let fullFilterLabel =
        <>
            {filterLabel}
            <span className="ms-2 text-muted">{count}</span>
        </>;

    /**
     * Only create a filter button if the filter is actionable.
     */
    let component = null;
    if (filterModel.isActionable()) {
        if (props.component && props.component === 'checkbox') {
            component =
                <Form.Check type="checkbox"
                            className="mt-1"
                            id={id}
                            name={id}
                            disabled={! filterModel.isActionable()}>
                    <Form.Check.Input type="checkbox"
                                      name={id}
                                      onChange={props.handleFilterChange}
                                      checked={checked}
                                      aria-checked={checked}
                                      title={filterLabel} />
                    <Form.Check.Label type="checkbox"
                                      aria-label={(checked ? 'Remove filter for ':'Filter results for ') + filterLabel}>
                        {fullFilterLabel}
                    </Form.Check.Label>
                </Form.Check>
        } else {
            component =
                <Button id={id} name={id} title={filterLabel}
                        onClick={props.handleFilterChange}
                        active={checked}
                        disabled={! filterModel.isActionable()}
                        aria-label={(checked ? 'Remove filter for ':'Filter results for ') + filterLabel}
                        aria-checked={checked}>
                    {fullFilterLabel}
                </Button>;
        }
    }

    return component;
};

FacetFilter.propTypes = {
    handleFilterChange: PropTypes.func.isRequired,
    filterModel: PropTypes.object.isRequired,
    component: PropTypes.string
};

export default FacetFilter;